import { rivermeadowApi } from './api';

/**
 * Migration Profiles API endpoints
 */
export const migrationProfilesApi = rivermeadowApi.injectEndpoints({
    endpoints: (builder) => ({
        // Get migration profile by ID
        getMigrationProfile: builder.query({
            query: (migrationProfileId) => ({
                url: `migrationprofiles/${migrationProfileId}`,
                method: 'GET',
            }),
            providesTags: (result, error, migrationProfileId) => [
                { type: 'MIGRATION_PROFILES', id: migrationProfileId },
            ],
        }),

        // Delete source config from migration profile
        deleteSourceConfig: builder.mutation({
            query: ({ migrationProfileId, sourceConfigId }) => ({
                url: `migrationprofiles/${migrationProfileId}/sources/${sourceConfigId}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, { migrationProfileId }) => [
                { type: 'MIGRATION_PROFILES', id: migrationProfileId },
            ],
        }),

        // Create migration from profile (start migration)
        createMigrationFromProfile: builder.mutation({
            query: (migrationProfileId) => ({
                url: `migrationprofiles/${migrationProfileId}/migrations`,
                method: 'POST',
                body: {},
            }),
            invalidatesTags: ['MIGRATIONS'],
        }),
    }),
});

export const { useGetMigrationProfileQuery, useDeleteSourceConfigMutation, useCreateMigrationFromProfileMutation } =
    migrationProfilesApi;
